import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  userInfo: {
    borderTop: theme.card.border,
    borderBottom: theme.card.border,
    textTransform: 'initial',
    padding: '13px 0 13px 25px',
    '& div': {
      cursor: 'pointer',
      fontSize: '0.85rem'
    }
  },
  userName : {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: 210, 
    whiteSpace: 'nowrap'
  }
}))

export {
  useStyles
}
